import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections, renderUpsellFromFetch, fetchRecommendations } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
  }

  constructor() {
    super()

    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')
    this.cartStatus = utils.one('.js-cart-status')

    this.isCartPage = location.pathname.includes('/cart') === true

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.statusUpdated = this.statusUpdated.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  get selectedVariant() {
    return this.getVariantData().find((variant) => variant.id === Number(this.querySelector('[name="id"]').value))
  }

  statusUpdated() {
    const cartItemCount = utils.one('.js-cart-item-count')?.innerHTML || 1
    let item_title = this.dataset.productTitle
    if (this.selectedVariant && this.selectedVariant.title !== 'Default Title') {
      item_title += ' - ' + this.selectedVariant.title
    }
    const message = window.cartStrings.statusAdd.replace('#item#', item_title).replace('#count#', cartItemCount)
    this.cartStatus.innerHTML = message
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    let sections = 'mini-cart,header',
      upsellContainer = '.mini-cart__content'
    if (this.isCartPage) {
      sections = 'inline-cart,header'
      upsellContainer = '.inline-cart__container'
    }

    const formData = JSON.parse(serializeForm(this.form))

    const reducedFormData = Object.entries(formData).reduce((acc, [key, value]) => {
      // Handle direct item properties (id, quantity)
      const directItemMatch = key.match(/items\[(\d+)\]\[(\w+)\]/);
      if (directItemMatch) {
        const [, index, prop] = directItemMatch;
        if (!acc.items) acc.items = [];
        if (!acc.items[index]) acc.items[index] = {};
        acc.items[index][prop] = value;
        return acc;
      }

      // Handle nested properties (_bundle_handle, etc)
      const propertyMatch = key.match(/items\[(\d+)\]properties\[(.+?)\]/);
      if (propertyMatch) {
        const [, index, propertyKey] = propertyMatch;
        if (!acc.items) acc.items = [];
        if (!acc.items[index]) acc.items[index] = {};
        if (!acc.items[index].properties) acc.items[index].properties = {};
        acc.items[index].properties[propertyKey] = value;
        return acc;
      }
      
      // Handle any other properties at the root level
      if (!key.startsWith('items[')) {
        acc[key] = value;
      }
      
      return acc;
    }, { items: [] });

    // Clean up the items array by removing empty slots and ensuring it's sequential
    formData.items = reducedFormData.items.filter(Boolean);

    reRenderShopifySections(
      await addToCart(formData, sections)
    )

    document.querySelector('.mini-cart')?.removeAttribute('empty')

    let recommendationId = ''
    const cartContent = document.querySelector(upsellContainer)
    if (cartContent) {
      recommendationId = cartContent.dataset.recommendation || ''
    }

    if (recommendationId) {
      if (this.isCartPage) {
        renderUpsellFromFetch(
          await fetchRecommendations(recommendationId, 'product-recommendations-cart'),
          '.inline-cart__upsell'
        )
      } else {
        renderUpsellFromFetch(
          await fetchRecommendations(recommendationId)
        )
      }
    }

    if (this.showMiniCartAfterSubmission && !this.isCartPage) {
      const selector = '.mini-cart'
      utils.one(selector).setAttribute('open', true)
      setTimeout(() => {
        utils.one(selector)._setupFocusTrap()
        utils.one('.mini-cart__close', utils.one(selector)).focus()

        this.statusUpdated()
      }, 300)
    } else {
      this.statusUpdated()
    }

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
